import styled from 'styled-components';

import { Grid } from '@decisiv/ui-components';

const SectionRow = styled(Grid.Row)`
  padding: 1.25rem;
`;

export default SectionRow;
